import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as WearableActions from '../../redux/actions/wearable.actions';
import AlarmIconCustom from '../CustomIcons/AlarmIconCustom.jsx';
import { BLUE } from '../../_config/consts';

const styles = theme => ({
  card: {
    padding: 20,
    marginBottom: 15,
    position: 'relative',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: '#d32f2f',
    marginRight: 15,
    width: 50,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#3f3f3f',
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: '#757575',
    margin: 0,
    marginTop: 5,
  },
  tableCard: {
    marginTop: 20,
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e8e8e8',
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: 'auto',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    backgroundColor: '#f8f9fa',
  },
  tableHeadRow: {
    borderBottom: '2px solid #dee2e6',
  },
  tableHeadCell: {
    borderRight: '1px solid #dee2e6',
    borderBottom: '2px solid #dee2e6',
    padding: '16px',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  tableCell: {
    borderRight: '1px solid #e8e8e8',
    borderBottom: '1px solid #e8e8e8',
    padding: '14px 16px',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  tableRow: {
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f7fa',
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  tableColumnText: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#495057',
    margin: 0,
  },
  tableCellText: {
    fontSize: 14,
    color: '#212529',
    fontWeight: 400,
    margin: 0,
  },
  emptyState: {
    textAlign: 'center',
    padding: 40,
    color: '#757575',
  },
  activeBadge: {
    backgroundColor: '#ffebee',
    color: '#d32f2f',
    padding: '6px 14px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    display: 'inline-block',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  resolvedBadge: {
    backgroundColor: '#e8f5e9',
    color: '#388e3c',
    padding: '6px 14px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    display: 'inline-block',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  refreshHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  refreshIcon: {
    fontSize: 30,
  },
  progress: {
    margin: 0,
    marginTop: 0,
    padding: 0,
    left: '50%',
    position: 'absolute',
    height: '38px !important',
    width: '38px !important',
    zIndex: 10000,
  },
});

@connect((state) => ({
  alarms: state.wearables.alarms.content,
  alarmsPagination: state.wearables.alarms.pagination,
  alarmsFilters: state.wearables.alarms.filters,
}))
class WearableAlarmsDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      lastUpdate: moment().valueOf(),
    };
  }

  async componentDidMount() {
    await this.onFetchAlarms();
  }

  async onFetchAlarms() {
    const { dispatch, wearable } = this.props;
    if (!wearable || !wearable.id) return;
    
    try {
      this.setState({ isLoading: true });
      await dispatch(WearableActions.fetchWearableAlarms(wearable.id));
      this.setState({ 
        isLoading: false,
        lastUpdate: moment().valueOf(),
      });
    } catch (error) {
      console.error('Error fetching alarms:', error);
      this.setState({ isLoading: false });
    }
  }

  onGetAlarmTypeLabel(type) {
    const typeMap = {
      EMERGENCY_BUTTON: 'emergencyButton',
      INSIDE_NOT_ALLOWED_AREAS: 'insideNotAllowedAreas',
      OUTSIDE_ALLOWED_AREAS: 'outsideAllowedAreas',
    };
    return typeMap[type] || type;
  }

  onGetStatusLabel(status) {
    const statusMap = {
      ACTIVE: 'active',
      RESOLVED: 'resolved',
    };
    return statusMap[status] || status;
  }

  onRowClick(wearableId) {
    const { dispatch } = this.props;
    dispatch(push(`/wearableAlarmsManagement?wearableId=${wearableId}`));
  }

  render() {
    const { classes, alarms } = this.props;
    const { isLoading, lastUpdate } = this.state;
    
    return (
      <div>
        <Card className={classes.card} elevation={2} style={{ opacity: isLoading ? 0.5 : 1 }}>
          <div className={classes.header}>
            <div className={classes.headerLeft}>
              <AlarmIconCustom className={classes.icon} />
              <div>
                <h3 className={classes.title}><Entity entity="alarmHistory" /></h3>
                <p className={classes.subtitle}><Entity entity="alarmHistoryDescription" /></p>
              </div>
            </div>
            <div className={classes.refreshHeader}>
              <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 10 }}>
                <Entity entity="lastUpdate" />: {moment(lastUpdate).format('LLL')}
              </h5>
              <IconButton
                disabled={isLoading}
                style={{ opacity: isLoading ? 0.5 : 1 }}
                onClick={() => this.onFetchAlarms()}
              >
                <RefreshIcon className={classes.refreshIcon} style={{ color: BLUE }} />
              </IconButton>
            </div>
          </div>
          
          <Card className={classes.tableCard} elevation={3}>
            <div className={classes.tableContainer}>
              {!_.isEmpty(alarms) ? (
                <Table className={classes.table}>
                  <TableHead className={classes.tableHead}>
                    <TableRow className={classes.tableHeadRow}>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          <Entity entity="date" />
                        </h5>
                      </TableCell>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          <Entity entity="type" />
                        </h5>
                      </TableCell>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          <Entity entity="status" />
                        </h5>
                      </TableCell>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          <Entity entity="lastUpdate" />
                        </h5>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {_.map(alarms, (alarm, index) => (
                      <TableRow 
                        key={index} 
                        className={classes.tableRow}
                        onClick={() => this.onRowClick(alarm.wearable.id)}
                      >
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            {alarm.createdAt ? moment(alarm.createdAt).format('LLL') : '---'}
                          </span>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            <Entity entity={this.onGetAlarmTypeLabel(alarm.type)} />
                          </span>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <span className={alarm.status === 'ACTIVE' ? classes.activeBadge : classes.resolvedBadge}>
                            <Entity entity={this.onGetStatusLabel(alarm.status)} />
                          </span>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            {alarm.lastUpdateTimestamp ? moment(alarm.lastUpdateTimestamp).format('LLL') : '---'}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <div className={classes.emptyState}>
                  <AlarmIconCustom style={{ color: '#bdbdbd', width: 35 }} />
                  <h3 style={{ color: '#bdbdbd', fontWeight: 'bold', marginTop: 10, fontSize: 18 }}>
                    <Entity entity="noAlarmsRecorded" />
                  </h3>
                </div>
              )}
            </div>
          </Card>
          {isLoading ? <CircularProgress color="primary" className={classes.progress} /> : null}
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(WearableAlarmsDetails);
